export enum FormType {
  None = 0,
  Patient = 1,
  CareProvider = 2,
  Related = 3,
  AnonymousForm = 4,
  PatientAndRelated = 5
}
